import { useMemo } from 'react';

import { FontAwesomeIcon } from '@appcharge/shared-ui';
import { useChecklistState } from 'state/hooks/setup-checklist.hook';

import { Progress } from 'components/ui/progress';

export const SetupChecklistHeader: React.FC = () => {
  const { isExpanded, toggleChecklistExpandedState, categories, tasks, isWebStore, isWebCheckout } =
    useChecklistState();

  const progress = useMemo(() => {
    if (isWebStore || isWebCheckout) {
      if (!tasks) return 0;
      
      const completedTasks = tasks.filter(
        (task) => task.status === 'done'
      ).length;

      return (completedTasks / tasks.length) * 100;
    }

    if (!categories) return 0;

    const completedCategories = categories.filter(
      (category) => category.status === 'done'
    ).length;

    return (completedCategories / categories.length) * 100;
  }, [categories, tasks, isWebStore, isWebCheckout]);

  return (
    <div
      className="flex flex-col w-full p-6"
      onClick={() => toggleChecklistExpandedState()}
    >
      <FontAwesomeIcon
        icon={`fa-solid ${isExpanded ? 'fa-down-left-and-up-right-to-center' : 'fa-up-right-and-down-left-from-center'}`}
        className="self-end cursor-pointer text-sm"
        style={{ color: 'var(--base-muted-foreground)' }}
      />
      <div className="text-sm font-semibold leading-5 font-sans mb-3">
        {'Setup checklist guide'}
      </div>
      <Progress
        value={progress}
        className="bg-base-secondary"
        indicatorClassName="bg-indigo-500"
      />
    </div>
  );
};
